import { useRef } from "react";
import { Button, UncontrolledTooltip } from "reactstrap";

const ToolbarItem = ({
  tooltip,
  onToggle,
  active = false,
  icon,
  id,
  disabled = false,
  style,
  hotkey,
}) => {
  const ref = useRef(null);

  return (
    <>
      <Button
        innerRef={ref}
        id={id}
        onClick={(e) => onToggle(e)}
        active={active}
        style={style}
        size="sm"
        disabled={disabled}
      >
        {icon}
      </Button>
      <UncontrolledTooltip
        target={ref}
        placement="top"
        trigger="hover focus-visible"
      >
        {tooltip}
        {/* {hotkey && <kbd>{hotkey}</kbd>} */}
      </UncontrolledTooltip>
    </>
  );
};

export default ToolbarItem;
